import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class HealthIssuesAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do you have any health issues, medical, or physical limitations that would impair or negatively impact your ability to perform oilfield work or the type of work you are applying for?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: true,
    modalTitle: 'Please Describe Any Limitations in Detail',
    additionalFormComponent: 'HealthIssuesForm',
  };
}
